import "./teamCard.css"
import { useState, useContext } from "react"
import UserCard from "../componentsScreenUsers/userCard.jsx"
import Select from 'react-select'
import {editUserTeam, deleteTeam} from '../../services/teamService.js'
import {SearchContext} from '../../context/searchNameContext.js'
import AsyncSelect from "react-select/async"


export default function TeamCard({team, handleRefreh}){

    const [expanded, setExpanded] = useState(false)
    const [value, setValue] = useState([])
    const {loadOptionsName} = useContext(SearchContext)

    const handleAddUserInTeam = () => {
        const usersId = value.map(v => v.value)
        usersId.map( async (id) => {
            const data = await editUserTeam(team.id, id)
            console.log(data)
        })    
    }

    const handleDeleteTeam = async () => {
        await deleteTeam(team.id)
        handleRefreh()
    }

    const loadFilteredOptions = async (inputValue) => {
        const options = await loadOptionsName(inputValue)
        const teamUserIds = team.users.map(u => u.id)
        return options.filter(option => !teamUserIds.includes(option.value))
    }

    return(
        <div className={`row`}>
            <div className="row-header" onClick={() => setExpanded(!expanded)}>
                <span className="nameTeam">{team.name}</span>
                <span className="numberUsers">Numero de usuarios: {team.users.length}</span>
                <span className="city">{team.city}</span>
                <span className="city">{team.address}</span>
                <button className="btn-delete" onClick={handleDeleteTeam}>eliminar</button>
                
            </div>
            {expanded && (
                <div className="expanded-content">
                    <p className="expanded-description">{team.description}</p>
                    <div>
                        <AsyncSelect 
                            isMulti
                            cacheOptions
                            defaultOptions
                            loadOptions={loadFilteredOptions}
                            value={value}
                            onChange={setValue}
                            placeholder="Buscar usuarios"
                        />
                        <button onClick={() => {
                            handleAddUserInTeam()
                            handleRefreh()}}>Añadir usuario(s)</button>
                    </div>
                    <div className="expanded-meta">
                        {
                            team.users.map((user, index) => (
                                <UserCard inTeam={true} key={index} user={user} refreshTeam={handleRefreh}></UserCard>
                            ))
                        }
                    </div>
                </div>
            )}
        </div>
    )
}